var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support-svgrepo-com 1",
    clipPath: "url(#clip0_684_119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C24.836 0 32 7.163 32 16C32 24.837 24.837 32 16 32C7.163 32 0 24.837 0 16C0 7.163 7.163 0 16 0ZM12 2.593C7.493 3.936 3.948 7.493 2.603 12H9.089C9.79 10.796 10.795 9.791 11.999 9.092L12 2.593ZM10.011 16.006C10.011 19.317 12.692 22 16 22C19.308 22 21.989 19.317 21.989 16.006C21.989 12.695 19.308 10.012 16 10.012C12.693 10.012 10.011 12.696 10.011 16.006ZM18 2.154C17.347 2.06 16.68 2.01 16 2.01C15.32 2.01 14.654 2.061 14 2.154V8.273C14.64 8.108 15.308 8.011 16 8.011C16.692 8.011 17.36 8.108 18 8.273V2.154ZM20 2.593V9.092C21.205 9.792 22.21 10.796 22.91 12H29.397C28.052 7.493 24.507 3.937 20 2.593ZM29.99 16.005C29.99 15.323 29.932 14.656 29.838 14H23.732C23.898 14.641 23.989 15.312 23.989 16.005C23.989 16.695 23.898 17.362 23.734 18H29.839C29.932 17.348 29.99 16.683 29.99 16.005ZM20 29.416C24.511 28.072 28.056 24.51 29.4 20H22.917C22.216 21.208 21.209 22.217 20.001 22.919V29.417L20 29.416ZM14 29.855C14.654 29.948 15.321 30 16 30C16.679 30 17.347 29.948 18 29.855V23.737C17.36 23.903 16.692 23.999 16 23.999C15.308 23.999 14.64 23.902 14 23.737V29.855ZM12 29.416V22.918C10.792 22.217 9.784 21.208 9.084 19.999H2.601C3.944 24.51 7.491 28.073 12 29.416ZM8.265 18C8.101 17.363 8.01 16.695 8.01 16.005C8.01 15.311 8.101 14.641 8.268 14H2.161C2.067 14.656 2.009 15.323 2.009 16.005C2.009 16.683 2.067 17.348 2.16 18H8.265Z",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDash);
export default __webpack_public_path__ + "static/media/support-dash.8ee47374199a707f540f383acc1264cf.svg";
export { ForwardRef as ReactComponent };